import React, { useEffect } from "react";
import MainLayout from '../layout/MainLayout'

function Logout() {


    return (
        <div>
            <MainLayout>
                <h1>You've been logged out.</h1>
                <p>Thanks for visiting. Come back soon.</p>
            </MainLayout>

        </div>
    )
}

export default Logout
